module.exports = __webpack_public_path__ + "static/media/Krishnan-Mehta.abc562ab.jpg";